import React, { FC } from 'react';
import { CreateArtView } from '../components';

export const CreateArtPage: FC = () => {
  return <CreateArtView />;
};
